export const ArticleRoutes = [
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import(
      /* webpackChunkName: "Article" */
      '@pages/article-detail/index'
    )
    ,
  },
]

